var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M8 .665a7.335 7.335 0 0 0-2.328 14.334c.367.068.5-.158.5-.352v-1.223c-2.045.447-2.476-1.01-2.476-1.01-.334-.853-.817-1.082-.817-1.082-.668-.457.052-.448.052-.448.738.052 1.124.758 1.124.758.655 1.124 1.717.798 2.133.61.067-.457.253-.798.46-.98-1.61-.183-3.3-.798-3.3-3.547 0-.785.28-1.428.758-1.93-.076-.183-.328-.91.072-1.898 0 0 .605-.183 1.98.733a6.609 6.609 0 0 1 1.782-.244 6.616 6.616 0 0 1 1.782.244c1.375-.916 1.98-.733 1.98-.733.4.988.148 1.715.072 1.898.477.502.758 1.145.758 1.93 0 2.756-1.691 3.364-3.296 3.542.259.223.5.664.5 1.347v2.002c0 .191.133.42.5.352A7.335 7.335 0 0 0 8 .665z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.2c2ea21455fd2e61e8954595067ba518.svg";
export { ForwardRef as ReactComponent };